<template><div><h2 id="component-contribution" tabindex="-1" class="d-docsite--header-2">Component Contribution <a class="header-anchor d-link d-docsite--link d-link" href="#component-contribution" aria-hidden="true">#</a></h2>
<h3 id="design" tabindex="-1" class="d-docsite--header-3">Design <a class="header-anchor d-link d-docsite--link d-link" href="#design" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">TBD</p>
<h3 id="code" tabindex="-1" class="d-docsite--header-3">Code <a class="header-anchor d-link d-docsite--link d-link" href="#code" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">To make code changes in our Design System please first read the
<a href="https://github.com/dialpad/dialtone/blob/staging/.github/CONTRIBUTING.md#contributing" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">CONTRIBUTING.md</a>
in our Dialtone repository.</p>
<h2 id="adding-icons-and-illustrations" tabindex="-1" class="d-docsite--header-2">Adding Icons and Illustrations <a class="header-anchor d-link d-docsite--link d-link" href="#adding-icons-and-illustrations" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">If you need to add an icon into Dialtone, here’s how you would go about doing that.</p>
<h3 id="for-system-icons" tabindex="-1" class="d-docsite--header-3">For System Icons <a class="header-anchor d-link d-docsite--link d-link" href="#for-system-icons" aria-hidden="true">#</a></h3>
<ol class="d-docsite--ordered-list">
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Create a new branch starting with &quot;feat/&quot; in the name.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Place the exported SVG file(s) in the appropriate folder category inside <code v-pre>packages/dialtone-icons/src/svg/icons/</code></p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">If you need to add keywords related to the icon.</p>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Add the icon name to <code v-pre>packages/dialtone-icons/src/keywords-icons.json</code> into the correct category.</li>
<li class="d-docsite--list-element">Add the keywords array as the value. e.g.</li>
</ul>
<div class="language-json" data-highlighter="prismjs" data-ext="json"><pre v-pre><code class="language-json"><span class="line"><span class="token punctuation">{</span></span>
<span class="line">   <span class="token property">"arrows"</span><span class="token operator">:</span> <span class="token punctuation">{</span></span>
<span class="line">     <span class="token property">"arrow-left"</span><span class="token operator">:</span> <span class="token punctuation">[</span><span class="token string">"arrow"</span><span class="token punctuation">,</span> <span class="token string">"left"</span><span class="token punctuation">,</span> <span class="token string">"direction"</span><span class="token punctuation">]</span><span class="token punctuation">,</span></span>
<span class="line">     ...</span>
<span class="line">   <span class="token punctuation">}</span></span>
<span class="line"><span class="token punctuation">}</span></span>
<span class="line"></span></code></pre>
</div></li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Commit and push your branch.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Open a pull request.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Once approved it can be merged into staging and will go out in the next release.</p>
</li>
</ol>
<h3 id="for-system-illustrations" tabindex="-1" class="d-docsite--header-3">For System Illustrations <a class="header-anchor d-link d-docsite--link d-link" href="#for-system-illustrations" aria-hidden="true">#</a></h3>
<ol class="d-docsite--ordered-list">
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Create a new branch starting with &quot;feat/&quot; in the name.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Place the exported SVG file(s) in the appropriate folder category inside <code v-pre>packages/dialtone-icons/src/svg/illustrations/</code></p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">If you need to add keywords related to the illustration.</p>
<ul class="d-docsite--unordered-list">
<li class="d-docsite--list-element">Add the illustration name to <code v-pre>packages/dialtone-icons/src/keywords-illustrations.json</code> into the correct category.</li>
<li class="d-docsite--list-element">Add the keywords array as the value. e.g.</li>
</ul>
<div class="language-json" data-highlighter="prismjs" data-ext="json"><pre v-pre><code class="language-json"><span class="line"><span class="token punctuation">{</span></span>
<span class="line">   <span class="token property">"spot-illustrations"</span><span class="token operator">:</span> <span class="token punctuation">{</span></span>
<span class="line">     <span class="token property">"blank-space"</span><span class="token operator">:</span> <span class="token punctuation">[</span><span class="token string">"blank"</span><span class="token punctuation">,</span> <span class="token string">"space"</span><span class="token punctuation">]</span><span class="token punctuation">,</span></span>
<span class="line">     ...</span>
<span class="line">   <span class="token punctuation">}</span></span>
<span class="line"><span class="token punctuation">}</span></span>
<span class="line"></span></code></pre>
</div></li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Commit and push your branch.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Open a pull request.</p>
</li>
<li class="d-docsite--list-element">
<p class="d-docsite--paragraph">Once approved it can be merged into staging and will go out in the next release.</p>
</li>
</ol>
</div></template>


